import type { ChangeEvent, Ref } from "react";
import { forwardRef } from "react";
import clsx from "clsx";

import rootClasses from "./styles.module.scss";
import type { IBaseInputProps } from "./types";

import { isDigit } from "@/utils/number";

export const BaseInput = forwardRef(function BaseInput(
  props: IBaseInputProps,
  ref: Ref<HTMLInputElement>,
) {
  const { onlyDigit, maxValue, minValue, onChange, ...rest } = props;

  function changeHandler(event: ChangeEvent<HTMLInputElement>) {
    const value = event.target.value.trim();

    const number = Number(value);

    // allow user to clear the input value
    if (value === "") {
      onChange?.(event);
      return;
    }

    if (onlyDigit && !isDigit(value)) return;
    if (
      maxValue !== undefined &&
      (!Number.isFinite(number) || number > maxValue)
    )
      return;
    if (
      minValue !== undefined &&
      (!Number.isFinite(number) || number < minValue)
    )
      return;

    onChange?.(event);
  }

  return (
    <input
      ref={ref}
      {...rest}
      onChange={changeHandler}
      className={clsx([props.className, rootClasses.input])}
    />
  );
});
